import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from "@angular/forms";

export class TilknytForbrugerFormBuilder {
    public static opretForm(aktualInstallationForsyningId: string): UntypedFormGroup {
        return new UntypedFormBuilder().group({
            forsyningId: [aktualInstallationForsyningId],
            brugernavn: new UntypedFormControl(null, [Validators.required]),
            kodeord: new UntypedFormControl(null, [Validators.required])
        });
    }
}
